import {Fragment, useEffect, useState, useRef} from "react";
import Scoreboard from "../../components/cards/scoreboard/scoreboard";
import QuickFixDrills from "../../components/cards/quickFixAndDrills/quickFixAndDrills";
import Player from "../../components/player/player";
import {useAccelerator} from "../../hooks/acceleratorDataProvider";
import {Box, Button, Divider, Grid, useMediaQuery, useTheme} from '@mui/material';
import {Typography} from '@mui/material';
import React from "react"; 
import {Accelerator} from "../../interfaces/accelerator";
import {useLocation, useNavigate} from "react-router";
import {Course} from "../../interfaces/course";
import {Lesson} from "../../interfaces/lesson";
import {getLastPartOfUrl, getTimeFromSeconds, isDrillsPath} from "../../helpers/utils";
import {Link} from "../../interfaces/link";
import PageLoader from "../../components/loader/loader";
import Carousel from "../../components/carousel/carousel";
import {trainingProgramViewed} from "../../components/mixPanelEvents/mixPanelEvents";
import BreadcrumbsNav from "../../components/navigation/breadcrumbs-nav/BreadcrumbsNav";
import type { BreadcrumbItem } from "../../components/navigation/types/BreadcrumbItem";
import {useParams} from 'react-router-dom';
import { axiosRequest } from "../../helpers/axios";
import TrainingChallenges from "../../components/trainingChallenges/trainingChallenges";
import RecordResultsDialog from "../../components/dialogs/recordResultsDialog";
import ResultsDialog from "../../components/dialogs/resultsDialog";
import { DrillRecord } from "../../interfaces/drillRecord";
import { relative } from "path";

interface CurrentLesson extends Lesson {
    courseID: number,
    ordinal: number
}

const AcceleratorPage = () => {

    let params = useParams();
   const location = useLocation();
   const passedLesson = location.state
    const containerRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [accelerator, setAccelerator] = useState<Accelerator>({
        isCourse:false,
        ID: 0,
        courses: [],
        image: "",
        name: "",
        progress: 0,
        coach: 0,
        url: "",
        quickfix: [],
        first_time: false,
        promo:[],
        hasCpBanner:false,
        showVipBannerToAllLessons: false,
        ctaUrlForAllLessons: "",
        ctaTextForAllLessons: "",
        is_autoplay: false,
        collapsable_accordions: false
    });
    const [currentLesson, setCurrentLesson] = useState<CurrentLesson>({
        content: "",
        lesson_type: "",
        url: "",
        drill_redirect_url:"",
        records: [],
        ID: 0,
        complete: false,
        courseID: 0,
        duration: "",
        name: "",
        is_pro_edition: false,
        ordinal: 0,
        is_fav: false,
        link: {} as Link,
        video: {
            ID: 0,
            progress: 0,
            url: "",
            embed_url: "",
            duration: "",
            subheading: "",
            button_text: "",
            button_url: "",
            text_under_button: ""
        },
        drill: {
            game_rules: "",
            record_label: "",
            record_label_desc: "",
            scoring_system: "",
            subheading: ""
        },
        cta:{
            text:"",
            url:""
        },
        linkIcon: ""
    })
    const {loaded, accelerators, averageScore} = useAccelerator();
    const navigate = useNavigate();
    const quickFixDrillsRef = useRef<null | HTMLDivElement>(null);
    const [quickFixDrillsHeight, setQuickFixDrillsHeight] = useState(0);
    const [firstTime, setFirstTime] = useState(true);
    const [drillLessons, setDrillLessons] = useState<Lesson[]>([]);
    const [scrollOffset, setScrollOffset] = useState(0);
    const [recordResult, setRecordResult] = useState(false);
    const [resultsDialogOpen, setResultsDialogOpen] = useState(false);
    const [recordLesson, setRecordLesson] = useState<Lesson>({
        content: "",
        lesson_type: "",
        link: {} as Link,
        url: "",
        drill_redirect_url:"",
        records: [],
        is_fav: false,
        video: {
            ID: 0,
            progress: 0,
            url: "",
            embed_url: "",
            duration: "",
            subheading: "",
            button_text: "",
            button_url: "",
            text_under_button: ""
        },
        ID: 0,
        complete: false,
        duration: "",
        name: "",
        is_pro_edition: false,
        drill: {
            game_rules: "",
            record_label: "",
            record_label_desc: "",
            scoring_system: "",
            subheading: ""
        },
        cta:{
            text:"",
            url:""
        },
        linkIcon: ""
    });




    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
            setFirstTime(false);
        }, 200)
    }, []);

    useEffect(() => {
        axiosRequest("GET", "/wp-json/pg/v2/sc/drills")
            .then(response => {
                setDrillLessons(response.data.data.data)
            })
            .catch((error) => {
                console.log("Fetching drill data error:", error);
            });
    }, []);

    useEffect(() => {
        if(params.accelerator === "drills"){
            const getAllFetchedData = async () => {
                await axiosRequest("GET", '/wp-json/pg/v2/sc/drills-by-accelerator').then((response: any) => {
                    const { data } = response.data;
                    const accelerators = data?.accelerators;
                    if (accelerators && accelerators.length > 0) {
                        const searchedAccelerator = accelerators[0];
                        if (searchedAccelerator) {
                            if (params.lessonName) {
                                const allLessons: CurrentLesson[] = searchedAccelerator.courses.reduce((acc: CurrentLesson[], next: Course) => {
                                    return [...acc, ...(next.lessons.map((el, index) => {
                                        return { ...el, courseID: next.ID, ordinal: index }
                                    }))]
                                }, [])
        
                                const lesson = allLessons.find(lesson => {
                                    const lastPart = getLastPartOfUrl(lesson.url);
                                    return lastPart === params.lessonName;
                                });
        
                                if (lesson) {
                                    console.log("lesson_type:", lesson.lesson_type);
                                    if (lesson.lesson_type === 'video') {
                                        setCurrentLesson({ ...lesson, duration: getTimeFromSeconds(Number(lesson.video.duration)) });
                                    } else if (lesson.lesson_type === 'link') {
                                        window.open(lesson.link.url, "_self")
                                    } else {
                                    }
                                } else {
                                    window.open("/404", "_self");
                                }
                            } else if (params.courseName) {
                            } else {
                            }
                            setAccelerator(searchedAccelerator);
                        } else {
                            window.open("/404", "_self");
                        }
                    }
                }).catch(error => console.error(`Error: ${error}`)).finally(() => { });
            };
            getAllFetchedData();
        }
    }, [params]);

    const openRecordResultDialog = (event: any, lesson: Lesson) => {
        event.stopPropagation();
        if (lesson.drill) {
            if (isMobile) {
                setScrollOffset(window.scrollY);
                document.body.style.touchAction = 'none'
                document.body.style.position = 'fixed';
                document.body.style.top = -scrollOffset + 'px';
            }
            setRecordResult(true);
            setRecordLesson(lesson);
        }
    }

    const handleCloseDialog = () => {
        if (isMobile) {
            document.body.style.touchAction = 'auto';
            document.body.style.position = 'unset';
            window.scrollTo(0, scrollOffset)
        }
        setResultsDialogOpen(false);
    };
    

    useEffect(() => {
        if (loaded && accelerators && params.accelerator !== "drills") {
            let searchedAccelerator = accelerators.find(el => {
                const regexpSize = /([^/]+)\/?$/;
                const acceleratorUrlSlug = el.url.match(regexpSize);
                if (acceleratorUrlSlug && acceleratorUrlSlug.length > 1) {
                    return acceleratorUrlSlug[1] === params.accelerator
                }
                return false;
            })
            if (searchedAccelerator) {
                if (params.lessonName) {
                    const allLessons: CurrentLesson[] = searchedAccelerator.courses.reduce((acc: CurrentLesson[], next: Course) => {
                        return [...acc, ...(next.lessons.map((el, index) => {
                            return {...el, courseID: next.ID, ordinal: index}
                        }))]
                    }, [])
                    const lesson = allLessons.find(lesson => {
                        return getLastPartOfUrl(lesson.url) === params.lessonName
                    });

                    if (lesson) {
                        if (lesson.lesson_type === 'video') {
                            setCurrentLesson({...lesson, duration: getTimeFromSeconds(Number(lesson.video.duration))});
                        } else if (lesson.lesson_type === 'link') {
                            window.open(lesson.link.url, "_self")
                        }
                    } else
                        window.open("/404", "_self");
                } else if (params.courseName) {
                    const course = searchedAccelerator.courses.find(course => getLastPartOfUrl(course.url) === params.courseName);
                    if (course) {
                        const videoLesson = course.lessons.find(el => el.lesson_type === 'video');
                        if (videoLesson) {
                            const firstLesson = {
                                ...videoLesson,
                                courseID: course.ID,
                                ordinal: 0
                            };

                            setCurrentLesson({
                                ...firstLesson,
                                duration: getTimeFromSeconds(Number(firstLesson.video.duration))
                            });
                        } else {
                            const linkLesson = course.lessons.find(el => el.lesson_type === 'link');
                            if (linkLesson)
                                window.open(linkLesson.link.url, "_self")
                        }

                    } else {
                        window.open("/404", "_self");
                    }
                } else {
                    const videoLesson = searchedAccelerator.courses[0].lessons.find(el => el.lesson_type === 'video');
                    if (videoLesson) {
                        const firstLesson = {
                            ...videoLesson,
                            courseID: searchedAccelerator.courses[0].ID,
                            ordinal: 0
                        };
                        setCurrentLesson({...firstLesson, duration: getTimeFromSeconds(Number(firstLesson.video.duration))});
                    } else {
                        const linkLesson = searchedAccelerator.courses[0].lessons.find(el => el.lesson_type === 'link');
                        if (linkLesson)
                            window.open(linkLesson.link.url, "_self")
                    }
                }
                setAccelerator(searchedAccelerator);
            } else
                window.open("/404", "_self");
        }
        // eslint-disable-next-line
    }, [params, loaded, navigate]);

    useEffect(() => {
        const handleResize = () => {
            setTimeout(() => {
                if (quickFixDrillsRef.current)
                    setQuickFixDrillsHeight(quickFixDrillsRef.current.offsetHeight)
            }, 500)
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [loaded]);

    const updateDrillLessons = (lessonID: any, newRecord: DrillRecord) => {
        setDrillLessons((prevDrillLessons) => {
          const lessonExists = prevDrillLessons.some((lesson) => lesson.ID === lessonID);
      
          if (lessonExists) {
            return prevDrillLessons.map((lesson) => {
              if (lesson.ID === lessonID) {
                return {
                  ...lesson,
                  records: [newRecord, ...lesson.records],
                };
              } else {
                return lesson;
              }
            });
          } else {
            const newLesson = {
              ...recordLesson, // or currentLesson if appropriate
              records: [newRecord],
            };
            return [...prevDrillLessons, newLesson];
          }
        });
      };

      const editDrillRecord = (lessonID: number, updatedRecord: DrillRecord) => {
        setDrillLessons((prevDrillLessons) => {
            return prevDrillLessons.map((lesson) => {
                if (lesson.ID === lessonID) {
                    const updatedRecords = lesson.records.map((record) =>
                        record.record_id === updatedRecord.record_id ? updatedRecord : record
                    );
                    return {
                        ...lesson,
                        records: updatedRecords,
                    };
                } else {
                    return lesson;
                }
            });
        });
    };


    const removeDrillRecord = (lessonID: number, recordID: number) => {
        setDrillLessons((prevDrillLessons) => {
            return prevDrillLessons.map((lesson) => {
                if (lesson.ID === lessonID) {
                    const filteredRecords = lesson.records.filter(
                        (record) => record.record_id !== recordID
                    );
                    return {
                        ...lesson,
                        records: filteredRecords,
                    };
                } else {
                    return lesson;
                }
            });
        });
    };
      
  
  
  

    useEffect(() => {
        let vip = (currentLesson.lesson_type ==="cta" || currentLesson.cta ) ? "Yes" : "No";
        trainingProgramViewed(currentLesson, accelerator, vip)
        // eslint-disable-next-line
    }, [currentLesson]);


    const handleClick = (): void => {
        window.location.href = window.location.origin;
    };
    const isScratchClubPath = location.pathname.includes('/scratch-club/');
    const breadcrumbItems: readonly BreadcrumbItem[] = isScratchClubPath
        ? [
            { label: 'Scratch Club', onClick: (): void => navigate("/scratch-club/") },
            { label: accelerator.name },
        ]
        : [
            { label: 'Training', onClick: handleClick },
            { label: 'Scratch Club', onClick: (): void => navigate("/scratch-club/") },
            { label: accelerator.name },
        ];

    return (
        <Box sx={{ 
            paddingLeft: { xs: '15px', md: '50px' }, 
            paddingRight: { xs: '15px', md: '50px' } 
        }}>
            <Box sx={{ marginTop: '40px', marginBottom: '-10px' }}>
                <BreadcrumbsNav items={breadcrumbItems} separator="/" prefix="/" showIcon={true} />
            </Box>
            {!loaded && <PageLoader/>}
            {loaded &&
                <Fragment>
                    <Box my={{ xs: 2, md: 4 }}>
                        <Typography variant="h1"
                                    fontSize={{ xs: "36px", md: "32px" }}
                                    fontWeight={ 500 }
                                    textTransform={"uppercase"}
                                    fontFamily={"Repro"}
                                    >
                            {isDrillsPath(location.pathname) ? currentLesson.name : accelerator.name}
                        </Typography>
                    </Box>

                    <Player updateDrillLessons={updateDrillLessons} accelerator={accelerator} currentLesson={currentLesson}
                            quickDrillsHeight={quickFixDrillsHeight} firstTime={firstTime}></Player>
                    <Divider component="li" sx={{margin: 0, display: {xs: "block", md: "none"}}}/>
                   {/* {isDrillsPath(location.pathname)  && <TrainingChallenges  currentLesson={currentLesson} drillLessons={drillLessons.filter(el => el.name === currentLesson.name)} passedLesson={passedLesson}/>} */}
                   {isDrillsPath(location.pathname) && (() => {
        const filteredDrill = drillLessons.find(el => el.name === currentLesson?.name);
    if (filteredDrill && filteredDrill.records?.length > 0) {
        return (
            <TrainingChallenges
                currentLesson={currentLesson}
                drillLessons={[filteredDrill]}
                passedLesson={passedLesson}
                removeDrillRecord={removeDrillRecord}
                editRecordDrill={editDrillRecord}
            />
        );
    }
    return null;
})()}
                   <Box>
                    {/* Dzelal */}
      {/* {isDrillsPath(location.pathname) && (drillLessons.filter(el => el.name === currentLesson.name).length === 0) &&<Box
        sx={{
          backgroundColor: '#F6F5F8',
          display: 'flex',
          padding: '24px 0px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'stretch',
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            marginBottom: '16px',
          }}
        >
          '0' scores submitted
        </Typography>

        <Button
          variant="contained"
          sx={{
            backgroundColor: '#355ADD',
            '&:hover': {
              backgroundColor: '#163190',
            },
          }}
        onClick={(event) => openRecordResultDialog(event, currentLesson)}
        >
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            Record results
          </Typography>
        </Button>
        <RecordResultsDialog
                show={recordResult}
                setShow={(value) => setRecordResult(value)}
                lesson={recordLesson}
                callback={() => setResultsDialogOpen(true)}
            />

<ResultsDialog
                open={resultsDialogOpen}
                onClose={handleCloseDialog}
                onButton1Click={() => {
                    document.body.style.touchAction = 'auto';
                    document.body.style.position = 'unset';
                    navigate("/scratch-club/record", {state: {id: recordLesson}})
                }}
                onButton2Click={handleCloseDialog}
            />
      </Box>
      } */}
      {isDrillsPath(location.pathname) && (() => {
    const filteredDrill = drillLessons.find(el => el.name === currentLesson?.name);
    if (filteredDrill && filteredDrill.records?.length === 0) {
        return (
            <>
            <Typography sx={{fontSize:24, fontWeight: 800,marginTop:{xs:'32px',md:'40px'}, marginBottom:'12px'}}>{isDrillsPath(location.pathname) ? "Drill Scores" : "Training Challenges"}</Typography>
            <Box
                sx={{
                    backgroundColor: '#F6F5F8',
                    display: 'flex',
                    padding: '24px 0px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                }}
            >
                <Typography
                    sx={{
                        fontSize: 16,
                        fontWeight: 500,
                        marginBottom: '16px',
                    }}
                >
                    '0' scores submitted
                </Typography>

                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#355ADD',
                        '&:hover': {
                            backgroundColor: '#163190',
                        }
                    }}
                    onClick={(event) => openRecordResultDialog(event, currentLesson)}
                >
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 700,
                        }}
                    >
                        Record results
                    </Typography>
                </Button>
                <RecordResultsDialog
  show={recordResult}
  setShow={(value) => setRecordResult(value)}
  lesson={recordLesson}
  callback={(data) => {
    setResultsDialogOpen(true);
    // Update the drillLessons state
    setDrillLessons((prevDrillLessons) => {
      // Check if the lesson already exists in drillLessons
      const lessonExists = prevDrillLessons.some(
        (lesson) => lesson.ID === recordLesson.ID
      );

      if (lessonExists) {
        // If lesson exists, update its records
        return prevDrillLessons.map((lesson) => {
          if (lesson.ID === recordLesson.ID) {
            return {
              ...lesson,
              records: [data, ...lesson.records], // New record at the beginning
            };
          } else {
            return lesson;
          }
        });
      } else {
        // If lesson doesn't exist, add a new lesson with the new record
        const newLesson = {
          ...recordLesson,
          records: [data],
        };
        return [...prevDrillLessons, newLesson];
      }
    });
  }}
/>
                <ResultsDialog
                    open={resultsDialogOpen}
                    onClose={handleCloseDialog}
                    onButton1Click={() => {
                        document.body.style.touchAction = 'auto';
                        document.body.style.position = 'unset';
                        navigate("/scratch-club/record", { state: { id: recordLesson } });
                    }}
                    onButton2Click={handleCloseDialog}
                />
            </Box>
            </>

        );
    }
    return null;
})()}
                  </Box>
                    <Grid ref={quickFixDrillsRef}
                          sx={{marginY: {xs: 3, md: 5}}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={isDrillsPath(location.pathname) ? undefined : 8} position="relative">
                                <Typography 
                                    variant="h1"
                                    ml={{xs: 2, md: 0}}
                                    fontSize={{xs: "18px", md: "22px"}}
                                    fontWeight={{xs: 500, md: 500}}
                                    sx={{
                                        fontFamily: "Repro",
                                        textTransform: "uppercase"
                                    }}
                                    >
                                        {isDrillsPath(location.pathname) ? "Popular on Performance Golf" : " Quick Fix & Drills"}
                                </Typography>

                                <Grid container mt={2}>
                                    {!isMobile && <Carousel items={accelerator.quickfix}/>}
                                    {isMobile && (
                                        <Box
                                            ref={containerRef}
                                            id="drillsContainer"
                                            display="flex"
                                            style={{
                                                overflowX: "scroll",
                                                overflowY: "hidden",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {accelerator.quickfix.map((drill, index) => (
                                                <QuickFixDrills key={index} drill={drill}
                                                                last={index + 1 === accelerator.quickfix.length}></QuickFixDrills>
                                            ))}
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                            {!isMobile && !isDrillsPath(location.pathname) && <Grid item md={4} sx={{minWidth: "auto"}}>
                                <Scoreboard score={averageScore}></Scoreboard>
                            </Grid>}
                        </Grid>
                    </Grid>
                </Fragment>
            }
        </Box>
    );
};


export default AcceleratorPage;